<template>
  <slot></slot>
</template>
<script>
import { onErrorCaptured, defineComponent } from 'vue';
import { logWebHrError } from '@/core/logger/log-wrapper';

export default defineComponent({
  name: 'error-boundary',
  props: {
    name: {
      type: String,
      default: 'Error boundary',
    },
    module: {
      type: String,
      required: true,
    },
  },
  emits: ['error'],
  setup(props, { emit }) {
    onErrorCaptured((err, vm, info) => {
      const error = err instanceof Error ? err : new Error(String(err));
      const componentName = vm?.$?.type?.name ?? '';
      let message = props.name;

      if (componentName) {
        message += ` [${componentName}] ${error.message}`;
      }

      logWebHrError(
        message,
        {
          context: props.module,
          metadata: {
            ...(componentName && { component: componentName }),
            name: error.name,
            message: error.message,
            info,
          },
        },
        error
      );

      emit('error', error);

      return false; // Prevent the error from propagating further
    });
    return {};
  }
})
</script>
